import authInstance from "../utilities/axios/authInstance";

export const allShifts = () => authInstance.get('shifts');

export const oneShift = (id) => authInstance.get('shifts/' + id);

export const addShift = (shift) => authInstance.post('shifts', shift);

export const updateShift = (id, shift) => authInstance.put('shifts/' + id, shift);

export const removeShift = (id) => authInstance.delete('shifts/' + id);

export const searchShifts = (shift) => authInstance.get('search/shifts', {
    params: {
        name: shift
    }
});